export let json = {
  "@type": "HowToTip",
  "text": "The creases created up until this point will be guiding lines for creating the four walls of your planter box."
}